import { Model } from "@/models/Model";
export class User extends Model {
    static fromJson(json) {
        return new User(json.ueid, json.uid, json.username, json.displayname, json.role);
    }
    constructor(ueid, uid, username, displayname, role) {
        super();
        this.data.ueid = ueid;
        this.data.uid = uid;
        this.data.username = username;
        this.data.displayname = displayname;
        this.data.role = role;
    }
    insert() {
        return Promise.reject();
    }
    update() {
        return Promise.reject();
    }
    get ueid() {
        return this.data.ueid;
    }
    get uid() {
        return this.data.uid;
    }
    get username() {
        return this.data.username;
    }
    get displayname() {
        return this.data.displayname;
    }
    get role() {
        return this.data.role;
    }
}
//# sourceMappingURL=User.js.map